module.exports = __webpack_public_path__ + "img/tree-07-g-trunk.2a699f9c.png";